
import { useContext } from 'react';
import { DebtsContext } from './DebtProvider';

export const useDebts = () => {
  const context = useContext(DebtsContext);
  if (context === undefined) {
    throw new Error('useDebts must be used within a DebtsProvider');
  }
  return context;
};
